import { StatusDot } from "@/components/data/StatusDot";

export function SafetyMargin({ paramId, label, value, unit, margin, lower = 0, upper = 100, state = "normal" }) {
  const pos = Math.max(0, Math.min(100, ((value - lower) / (upper - lower || 1)) * 100));
  const piRaw = (value - (lower + upper) / 2) / ((upper - lower) / 2);
  const pi = Math.max(-1, Math.min(1, piRaw)).toFixed(2);
  return (
    <div className="space-y-2" data-testid={`safety-margin-${paramId}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-heading text-[var(--oim-text-secondary)]">{label}</span>
        <StatusDot state={state} />
      </div>
      <div className="font-mono-data text-lg font-semibold text-[var(--oim-text)]">{value} <span className="text-xs text-[var(--oim-text-muted)]">{unit}</span></div>
      <div className="text-[10px] text-[var(--oim-text-dim)] font-mono-data">Margin to limit {margin} {unit}</div>
      <div className="relative h-1.5 rounded-full" style={{ backgroundColor: "var(--oim-surface-softer)" }}>
        <div className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-[var(--oim-text)]" style={{ left: `${pos}%` }} />
      </div>
      <div className="flex justify-between text-[9px] font-mono-data text-[var(--oim-text-dim)]">
        <span>L</span>
        <span>Π = {pi >= 0 ? "+" : ""}{pi}</span>
        <span>U</span>
      </div>
    </div>
  );
}
